const axios = require('axios')
/*eslint-disable*/
export default {
  getRooms(callback) {
    axios.get('/admin/api/collections/get/Chambres?token=95e286780d3113b098c387acf92ce1')
    .then(function (response) {
      callback(response.data)
    })

  },
  getImages(callback) {
    axios.get('/admin/api/collections/get/Image?token=95e286780d3113b098c387acf92ce1')
    .then(function (response) {
      console.log(response.data)
      callback(response.data)
    })
  },
  getReviews(callback) {
    axios.get('/admin/api/collections/get/Reviews?token=95e286780d3113b098c387acf92ce1')
    .then(function (response) {
      console.log(response.data)
      callback(response.data)
    })
  }
}
/*eslint-disable*/